import React from "react";
import "./Button.css";

function Button({
  onClick = () => {},
  text = "default",
  height = "80px",
  width = "200px",
}) {
  return (
    <div
      class="button"
      style={{ width, height, lineHeight: height }}
      onClick={onClick}
    >
      {text}
    </div>
  );
}

export default Button;
